<template>
    <div>
        <b-form enctype="multipart/form-data">
            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Anexo"
                    label-for="attachment"
                    :label-cols="3"
                    :horizontal="false">
                        <file-drop-area-component :multiple="true" v-model="fileToSend"></file-drop-area-component>
                        <div>
                            <b-list-group  v-for="item in fileToSend">
                                <b-list-group-item variant="light">
                                    <i class="fa fa-file-o fa-lg mr-2"></i>
                                    <span>{{ item.name }}</span>
                                </b-list-group-item>
                                
                            </b-list-group>
                        </div>
                    </b-form-group>          
                </b-col>
            </b-row>
        </b-form>

        <b-input-group class="mb-4">
            <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
        </b-input-group>
    
        <div slot="footer" class="text-right">
            <b-button variant="github" class="mr-1 btn-brand" @click="uploadFiles()"><i class="fa fa-check"></i><span>Enviar Imagens</span></b-button>
        </div>

    </div>    
</template>


<script>
import Vue from 'vue'
import axios from "axios";

//import ProductSelectComponent from '../stock/ProductSelectComponent'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'
import FileDropAreaComponent from '../../components/FileDropAreaComponent.vue'


const toastTypes = {
success: 'success',
error: 'error',
info: 'info',
warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
return miniToastr[type](message, title, timeout, cb)
}

const options = {
success: toast,
error: toast,
info: toast,
warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'paymentComponent',
    props: {
        apId: Long,
        companyId: Long
    },
    components: {
//        ProductSelectComponent
        FileDropAreaComponent
    },
    data: () => {
        return {
            totalValueField: '',
            accountDueDateField: '',

            accountDueDate: '',
            totalValue: 0,
            fileToSend: null,

            paymentVoucher: '',
            paymentAccountId: 0,
            currentItem: { st: 'A'},
            errorMessage: "",
            notes: "",

        }
    },
    computed: {
        propApId() {
            return this.apId
        },
        propCompanyId() {
            return this.companyId
        }
        
    },
    methods: {

        async saveItem() {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            let formData = new FormData();

            formData.append('accountId', s.item.id)
            formData.append('totalValue', s.totalValue)
            formData.append('file', this.fileToSend);
            formData.append('notes', s.notes)
            formData.append('uid', currentUser.id);
            formData.append('sid', currentUser.sid);
            
            var url = this.$store.state.ws_url + "/finance/ap/payment"
            if(s.accountType == 'R')
                url = this.$store.state.ws_url + "/finance/ar/payment"

            console.log(url)

            /*
            await axios.post(
                url,
                formData
            ).then(function(resp) {
                //console.log("Pagamento processado")                
                s.$emit('item-selected', formData);                

            }).catch(function(error) {
                //console.log("Erro ao processar pagamento")
                console.log(error)
            })
            */
            
        },

        uploadFiles() {
            this.saveItem();
        },
        refreshData() {
            
        }
    },
    mounted: function() {
    }

}

</script>